import { CountryTypes, DropdownOption, FoodCategories, FoodTypes, GenericOption, SourceTypes } from "@/types";
import { apiSlice } from "@/redux/apiSlice";

export const Common = apiSlice.injectEndpoints({
    endpoints(builder) {
        return {
            getCountries: builder.query<CountryTypes[], void>({
                query: () => ({
                    url: "/countries",
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                }),
                providesTags: ["Common"],
            }),
            getAllSource: builder.query<SourceTypes[], void>({
                query: () => ({
                    url: "/sources",
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                }),
                providesTags: ["Common"],
            }),
            getBusinessType: builder.query<{ value: string, label: string }[], void>({
                query: () => ({
                    url: "/business-type",
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                }),
                transformResponse: ((resp: GenericOption[]) => {
                    return resp.map((item) => ({
                        value: String(item.id),
                        label: item.name
                            .split("_")
                            .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(" "),
                    }));
                }),
                providesTags: ["Common"],
            }),
            getFoodUnits: builder.query<DropdownOption[], void>({
                query: () => ({
                    url: "/food/unit",
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                }),
                transformResponse: ((resp: FoodTypes) => {
                    return resp.data.map((item) => ({
                        value: item.id,
                        label: item.unit_key,
                    }));
                }),
                providesTags: ["Common"],
            }),
            getFoodCategories: builder.query<DropdownOption[], void>({
                query: () => ({
                    url: "/food/category",
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                }),
                transformResponse: ((resp: FoodCategories) => {
                    return resp.data.map((item) => ({
                        value: item.id,
                        label: item.name,
                    }));
                }),
                providesTags: ["Common"],
            }),

        };
    },
});

export const {
    useGetCountriesQuery,
    useGetAllSourceQuery,
    useGetBusinessTypeQuery,
    useGetFoodUnitsQuery,
    useGetFoodCategoriesQuery
} = Common;
